// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltip":"cvv-input__tooltip___3mGzv","label":"cvv-input__label___12k0S","label-container":"cvv-input__label-container___3bPrd","labelContainer":"cvv-input__label-container___3bPrd"};
    if(module.hot) {
      // 1695609769132
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  